import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-newsletter-page',
  templateUrl: './newsletter-page.component.html',
  styleUrls: ['./newsletter-page.component.css'],
})
export class NewsletterPageComponent implements OnInit {
  displayedColumns: string[] = [
    'index',
    'title',
    'newsletterName',
    'incubatorName',
    'action',
  ];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  private newslistApi = environment.url + environment.homenewsletterList;
  private deleteApi = environment.url + environment.newsletterDelete;
  newsletterName: any;
  /**
   * Constructor for the NewsletterPageComponent.
   * @param makeapi The API service provider.
   * @param getdata The Value service provider.
   * @param notify The Notification service provider.
   * @param dialog The Material dialog service provider.
   */
  constructor(
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {
    // Initialize the MatTableDataSource with empty data
    this.dataSource = new MatTableDataSource();
  }
  roleValue;

  /**
   * Initializes the component.
   * Sets the visibility flag, retrieves the user's role,
   * and fetches the newsletter list and reset list.
   */
  ngOnInit(): void {
    // Hide the visibility source
    this.getdata.isVisibleSource.next(false);
    // Retrieve the user's role from session storage
    this.roleValue = sessionStorage.getItem('role');
    // Fetch the list of newsletters
    this.newsletterList();
    // Reset the list
    this.restList();
  }
  newsLetterList;
  /**
   * Calculates the total number of pages based on the count of data.
   * This function is called whenever the data count changes.
   */
  Pagination_Count() {
    // Reset the loading state
    this.loading = false;
    // Get the total count of data
    let totalcount = this.numberOfList;
    // Set the total part count to the total count
    this.totalPartCount = totalcount;
    // Calculate the total number of pages by dividing the total count by the current page count
    // and rounding up to the nearest whole number.
    this.totalPages = Math.ceil(this.totalPartCount / this.currentPageCount);
  }
  p1 = 1;
  totalPartCount: any;
  paginationCount = 1;
  currentPageCount = 9;
  loading = false;
  numberOfList = 0;
  currentPage = 1;
  totalPages = 4;
  show_page = false;
  pagecount = 1;
  startCount = 1;
  EndCount = 9;
  countList = 0;
  /**
   * Handles pagination of the newsletter list.
   * @param page - The page to navigate to. Can be 'prev' or 'next'.
   */
  paginatePartList(page: string): void {
    this.show_page = true;
    if (page == 'prev' && this.currentPage > 1) {
      // Decrement the page count
      this.pagecount = this.pagecount - 1;
      // If the user is not on the first page
      if (this.currentPage > 1) {
        // Decrement the current page number
        let prevcount = this.currentPage;
        prevcount--;
        // Update the pagination count
        this.paginationCount = prevcount;
        // Update the current page number
        this.currentPage = prevcount;
      } else {
        // If the user is on the first page, set the pagination count to 1
        this.paginationCount = 1;
      }
      // Adjust the start and end counts for the new page
      if (this.EndCount != this.numberOfList) {
        // Decrement the start count
        this.startCount = this.startCount - this.currentPageCount;
        // Decrement the end count
        this.EndCount = this.EndCount - this.currentPageCount;
      } else {
        // If we are at the last page, adjust the start and end counts to the last page
        this.startCount = this.startCount - this.currentPageCount;
        this.EndCount = this.EndCount - this.countList;
      }
    } else {
      // Increment the page count
      this.currentPage = this.currentPage + 1;
      this.pagecount = this.pagecount + 1;
      // If the user is not on the last page
      if (this.currentPage > 1) {
        // Increment the current page number
        let nextcount = this.currentPage - 1;
        nextcount++;
        // Update the pagination count
        this.paginationCount = nextcount;
      }
      // If the user is not on the last page
      if (this.currentPage != this.totalPages) {
        // Increment the start and end counts for the new page
        this.startCount = this.startCount + this.currentPageCount;
        this.EndCount = this.EndCount + this.currentPageCount;
      }
    }

    // Call the API to fetch the list of newsletters based on the new pagination parameters
    this.selectIncubator('');
  }

  searchValue = false;
  searchList = [];
  list: any = {};

  /**
   * Fetches the list of newsletters from the API based on the selected incubator.
   * If the searchValue is true, it fetches the list of newsletters from the API based on the search input.
   * Otherwise, it fetches the list of newsletters from the API based on the current pagination parameters.
   * @param value - the selected incubator name
   */
  selectIncubator(value) {
    this.searchValue = true;
    this.searchList = [];
    this.list = {
      pageNumber: this.currentPage,
      listSize: this.currentPageCount,
    };

    if (value != '') {
      // Search value is present, add it to the request parameters
      this.list.searchStrig = value;
    }

    // Call the API to fetch the list of newsletters
    this.newsListApi();
  }

  noData = true;
  disList: any = [];
  pageSize: number = 12;
  pageNumber: number = 1;
  searchString: '';
  /**
   * Fetches the list of newsletters from the API using the current pagination parameters.
   * Updates the request parameters using the component fields and calls the API.
   */
  newsletterList() {
    // Update the request parameters
    this.list = {
      pageNumber: this.currentPage, // Current page number
      listSize: this.currentPageCount, // Number of items per page
      searchStrig: this.searchString, // Search string to filter newsletters
    };
    // Call the API method with the current list parameters
    this.newsListApi();
  }
  /**
   * Fetches the list of newsletters from the API using the current pagination parameters.
   * Subscribes to the API response and updates the component's data fields based on the response.
   */
  newsListApi() {
    // Call the API method with the current list parameters
    this.makeapi
      .method(this.newslistApi, this.list, 'postunauth')
      .subscribe((data) => {
        // Set the displayed list and data source for the table
        this.disList = data.responsemodelList;
        this.dataSource = new MatTableDataSource(data.responsemodelList);

        // Check if the API response was successful
        if (data.responseStatus === 'Success') {
          // If there are pages available, update the component's data fields
          if (data.totalPages !== 0) {
            this.noData = false;
            this.numberOfList = data.listSize;
            this.totalPages = data.totalPages;

            // Calculate the count of items and update pagination counts
            this.countList = data.incubators.length;
            if (
              this.currentPage === this.totalPages &&
              this.countList !== this.numberOfList
            ) {
              this.startCount = this.startCount + this.currentPageCount;
              this.EndCount = this.numberOfList;
            } else if (this.countList === this.numberOfList) {
              this.startCount = 1;
              this.EndCount = this.numberOfList;
            }
            // Update the search list with incubator data
            this.searchList = data.incubators;
          } else {
            // No pages available, clear the search list
            this.noData = false;
            this.searchList = [];
          }
        } else {
          // If the response was not successful, clear the search list
          this.noData = false;
          this.searchList = [];
        }
      });
  }
  /**
   * Resets the list with the current pagination parameters and fetches the updated list of newsletters.
   * Initializes the list object with the current page number and size, then calls the API.
   */
  restList() {
    // Set the pagination parameters for the list
    this.list = {
      pageNumber: this.currentPage, // Current page number
      listSize: this.currentPageCount, // Number of items per page
    };

    // Fetch the updated list of newsletters from the API
    this.newsListApi();
  }
  viewmore() {}
  /**
   * Lifecycle hook that is called after the component's view has been fully initialized.
   * Sets the paginator for the MatTableDataSource.
   */
  ngAfterViewInit() {
    // Set the paginator for the MatTableDataSource
    this.dataSource.paginator = this.paginator;
  }

  /**
   * Deletes a newsletter by its ID.
   * @param id - The ID of the newsletter to be deleted.
   * @returns A subscription to the delete API call.
   */
  deleteNewletters(id) {
    // Make an API call to delete the newsletter with the specified ID
    return this.makeapi
      .method(this.deleteApi + id, '', 'delete')
      .subscribe((data) => {
        // Check if the response status is 'Success'
        if (data.responseStatus == 'Success') {
          // Notify the user of the successful deletion
          this.notify.notifysuccess(data.responseMessage);
          // Refresh the newsletter list to reflect the deletion
          this.newsListApi();
        } else {
          // Notify the user of an error during deletion
          this.notify.notifyError(data.responseMessage);
        }
      });
  }
}
